import { Grid, GridColumn } from '@progress/kendo-react-grid'
import * as React from 'react'
import { connect } from 'react-redux'
import { Col, Row } from 'reactstrap'
import * as App from '../../app/types'
import { FlashMessage } from '../../components/flash-message'
import { Loading } from '../../components/loading'
import * as GridCell from '../grid-cell'
import * as Types from './types'

import './styles.css'

const IntegrationReportsHeader = () =>
<div>
  <FlashMessage />
  <Row className="margin-auto">
    <Col sm="12" md="10" className="text-left page-header--padding">
      <div className="page-header">
        <span className="title">Integration Reports</span>
      </div>
    </Col>
  </Row>
</div>

const ReportsTable = ({integrationReports}: any) => {
  let systemName: string = ''
  if (integrationReports.data.length > 0) {
    systemName = integrationReports.data[0].integration_name
  }
  return integrationReports.view.isFetching ?
    <span>
      <Loading size={Loading.Sizes.MEDIUM}/>
    </span>
    :
    <div className="reports-container">
      <div>
        <Grid data={integrationReports.data}
              resizable={true}>
          <GridColumn field="sync_type_name" title="Type" width={200}/>
          <GridColumn field="added_to_rasa" title="Records added to Rasa" width={200}/>
          <GridColumn field="added_to_target" title={'Records added to ' + systemName} width={200}/>
          <GridColumn field="updated_in_rasa" title="Records updated in Rasa" width={200}/>
          <GridColumn field="updated_in_target" title={'Records updated in ' + systemName} width={200}/>
          <GridColumn cell={GridCell.DateTimeCell} field="start_date_time" title="Start Date" width={150}/>
          <GridColumn cell={GridCell.DateTimeCell} field="end_date_time" title="End Date" width={150}/>
          <GridColumn field="log_file_location" title="Log location" width={200}/>
        </Grid>
      </div>
    </div>
}

const ReportsTableConnected = connect(
  ({integrationReports, app}: Types.WrappedState & App.WrappedState) => ({integrationReports, app}),
)(ReportsTable)

export const IntegrationsReports = () =>
<div>
  <IntegrationReportsHeader/>
  <ReportsTableConnected/>
</div>



// WEBPACK FOOTER //
// ./src/pages/integration-reports/component.tsx